import { render, staticRenderFns } from "./loadFail.vue?vue&type=template&id=36770d4c&scoped=true&"
import script from "./loadFail.vue?vue&type=script&lang=js&"
export * from "./loadFail.vue?vue&type=script&lang=js&"
import style0 from "./loadFail.vue?vue&type=style&index=0&id=36770d4c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36770d4c",
  null
  
)

export default component.exports